import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import TiktokPixel from "tiktok-pixel";

export default function AnalyticsRouteTracker() {
  const loc = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    const path = loc.pathname + loc.search;
    const url = window.location.href;

    // avoid duplicate fires if the router re-renders without path change
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;
    if (typeof window.__trackPage === "function") {
      window.__trackPage({ path, url });
      // console.log("tracked", path, url);
    }

    TiktokPixel.init("CQOFVN3C77U11VCBB9AG");
    TiktokPixel.pageView();
    // console.log("tiktok init");
  }, [loc.pathname, loc.search]);

  return null;
}
